import { UploadFile } from 'ngx-uploader';
import { RRFileContainerModel } from './file-container-model.model';

export class FileUploadContainer<T extends RRFileContainerModel> {
  containerModel: T;
  file: UploadFile & { imagePreview?: any };
}
